<div class="idea-attachments">
  <span class="idea-attachments__label" *ngIf="showLabel">{{ 'attachments.label' | translate }}</span>
  <p class="idea-attachments__hint">{{ 'attachments.hint' | translate: { max: maxFiles } }}</p>

  <label class="idea-attachments__select" [class.disabled]="files?.length >= maxFiles">
    {{ 'attachments.select' | translate }}
    <input type="file" multiple [accept]="accept" (change)="onSelect($event)"
           [disabled]="files?.length >= maxFiles">
  </label>

  <ul class="idea-attachments__list" *ngIf="files?.length">
    <li *ngFor="let file of files; let i = index">
      <span class="idea-attachments__name" [title]="file.name">{{ file.name }}</span>
      <span class="idea-attachments__size">{{ formatSize(file.size) }}</span>
      <button type="button" class="idea-attachments__remove" (click)="onRemove(i)"
              [attr.aria-label]="'attachments.remove' | translate">X</button>
    </li>
  </ul>
</div>
